import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';

import { FinancialData } from '@app/shared/interfaces/data/financial-data.interface';
import { FinancialSimulatorComponent } from './financial-simulator/financial-simulator.component';
import { FinancialSimulatorMobileComponent } from './financial-simulator-mobile/financial-simulator-mobile.component';

@Component({
    selector: 'app-financial-cart',
    standalone: true,
    imports: [CommonModule, SharedModule, TranslateModule, FinancialSimulatorComponent, FinancialSimulatorMobileComponent],
    templateUrl: './financial-cart.component.html',
    styleUrl: './financial-cart.component.scss',
})
export class FinancialCartComponent {
    @Input() brand = '';
    @Input() model = '';
    @Input() financialData!: FinancialData;
    @Input() isPortraitDevice = false;

    @Output() isOpenedFinancialCart = new EventEmitter<boolean>();

    isOpenFinancialSimulator: boolean = false;
    //isOpenFinancialSimulator: Boolean = false;


    constructor() {}

    ngOnInit(): void {
        this.brand = this.brand;

        //console.log(this.financialData);
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    onShowFinancialSimulator(event: Event) {
        this.isOpenFinancialSimulator = true;
        this.isOpenedFinancialCart.emit(true);
    }

    onHideFinancialSimulator(event: Event) {
        this.isOpenFinancialSimulator = false;
        this.isOpenedFinancialCart.emit(false);
    }
}
